import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import './mixins'
import './plugins'
import './thirdParty'

import './scss/style.scss'

Vue.config.productionTip = false

new Vue({
  name: 'Root',
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
